import EmblaCarousel from "embla-carousel";

function setupButtons(embla, root) {
  const prevBtn = root.querySelector("[data-embla-prev]");
  const nextBtn = root.querySelector("[data-embla-next]");

  const updateButtons = () => {
    if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
  };

  if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
  if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());

  embla.on("select", updateButtons);
  embla.on("init", updateButtons);
}

export function initEmblaCarousel(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    loop: false,
    slidesToScroll: "auto",
  });

  setupButtons(embla, root);
}

export function initEmblaCarouselGallery(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    slidesToScroll: "auto",
  });

  setupButtons(embla, root);
}
